// Libraries
import styled from 'styled-components'
import { Subtitle, Title } from 'components/UI/Typography'

type ContainerProps = {
  backgroundImage?: string
}

export const Settings = styled.img`
  height: 60px;
  width: 60px;
`

export const ContainerLogo = styled.div`
  display: flex;
  justify-content: center;
  z-index: 1;
`

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 3.6rem - 20px);
  justify-content: end;
  width: 100%;
  ::before {
    content: '';
    background-color: ${({ theme }) => theme.colors.background.default};
    background-image: url(${({ backgroundImage }) => backgroundImage || ''});
    background-position: top 100px center;
    background-repeat: no-repeat;
    background-size: 100%;
    position: absolute;
    opacity: 0.32;
    bottom: 0px;
    top: 70px;
    right: 0px;
    left: 0px;
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    justify-content: flex-start;
    max-width: 1280px;
    margin: 0 auto;
    min-height: 100%;
    padding: 40px 8%;
    width: 100%;
    background-color: ${({ theme }) => theme.colors.background.default};
    background-image: url(${({ backgroundImage }) => backgroundImage || ''});
    background-position: right center;
    background-repeat: no-repeat;
    background-size: 40%;
    flex-direction: row;
    ::before {
      display: none;
      top: 0px;
    }
    & ${ContainerLogo} {
      display: none;
    }
  }
`

export const Content = styled.div`
  align-items: center;
  border-radius: 2.4rem 2.4rem 0 0;
  background: white;
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 50rem;
  padding: 3.2rem 7%;
  justify-content: start;
  width: 100%;
  z-index: 1;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    background-color: ${({ theme }) => theme.colors.background.default};
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 40px;
    height: 100%;
    justify-content: center;
    max-width: 57rem;
    padding: 4rem 3% 10rem 3%;
    position: relative;
    width: 55%;
    & ${Settings} {
      display: none;
    }
  }
`

export const Error = styled.img`
  height: 372px;
  width: 500px;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    height: 298px;
    width: 400px;
  }
`
export const Logo = styled.img`
  height: 80px;
  width: 80px;
  z-index: 1;
`

export const MainTitle = styled(Title).attrs(() => ({
  align: 'center',
}))`
  font-family: ${({ theme }) => theme.fontFamily.roboto};
  font-size: ${({ theme }) => theme.fontSize.sh1};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  line-height: 3.2rem;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    font-family: ${({ theme }) => theme.fontFamily.barlow};
    font-size: ${({ theme }) => theme.fontSize.h1};
    font-weight: ${({ theme }) => theme.fontWeight.semiBold};
    line-height: ${({ theme }) => theme.lineHeight.h1};
  }
`

export const Subtext = styled(Subtitle).attrs(() => ({
  align: 'center',
}))`
  color: ${({ theme }) => theme.colors.text.subdued};
  font-family: ${({ theme }) => theme.fontFamily.roboto};
  font-size: ${({ theme }) => theme.fontSize.copy1};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  line-height: ${({ theme }) => theme.lineHeight.sh3};
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    font-size: ${({ theme }) => theme.fontSize.sh3};
  }
`
